"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.API = void 0;
var axios_1 = __importDefault(require("axios"));
// interface IApiResponse {
//   success: boolean;
//   message: string;
//   content?: any;
// }
var API = /** @class */ (function () {
    function API() {
        // apiBaseURL = process.env.LETS_TRADE_USER_URL;
        this.bearerToken = process.env.LETS_TRADE_CLIENT_TOKEN;
    }
    API.prototype.apiGet = function (_a) {
        var baseUrl = _a.baseUrl, endpoint = _a.endpoint, authorization = _a.authorization;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, (0, axios_1.default)({
                            method: "GET",
                            url: "".concat(baseUrl, "/").concat(endpoint),
                            headers: this.getHeader(authorization),
                        })
                            .then(function (response) {
                            //// console.log(`api -> apiGet -> calls -> ${endpoint} SUCCESS:`, response);
                            return response.data;
                        })
                            .catch(function (error) {
                            //// console.log(`api -> apiGet -> calls -> ${endpoint} ERROR:`, error);
                            return _this.extractErrorMessage(error);
                        })];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    API.prototype.apiPost = function (_a) {
        var baseUrl = _a.baseUrl, endpoint = _a.endpoint, contentType = _a.contentType, content = _a.content, authorization = _a.authorization;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, (0, axios_1.default)({
                            method: "POST",
                            url: "".concat(baseUrl, "/").concat(endpoint),
                            headers: this.getHeader(authorization),
                            data: content,
                        })
                            .then(function (response) {
                            //// console.log(`api -> apiPost -> calls -> ${endpoint} SUCCESS:`, response);
                            return response.data;
                        })
                            .catch(function (error) {
                            // // console.log(`api -> apPost -> calls -> ${endpoint} ERROR:`, error);
                            return _this.extractErrorMessage(error);
                        })];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    API.prototype.apiPut = function (_a) {
        var baseUrl = _a.baseUrl, endpoint = _a.endpoint, contentType = _a.contentType, content = _a.content, authorization = _a.authorization;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, (0, axios_1.default)({
                            method: "PUT",
                            url: "".concat(baseUrl, "/").concat(endpoint),
                            headers: this.getHeader(authorization),
                            data: content,
                        })
                            .then(function (response) {
                            // console.log(`api -> apiPut -> calls -> ${endpoint} SUCCESS:`, response);
                            return response.data;
                        })
                            .catch(function (error) {
                            // console.log(`api -> apiPut -> calls -> ${endpoint} ERROR:`, error);
                            return _this.extractErrorMessage(error);
                        })];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    API.prototype.getHeader = function (authorization) {
        return {
            authorization: "Bearer ".concat(authorization !== null && authorization !== void 0 ? authorization : this.bearerToken),
            "content-type": "application/json",
        };
    };
    API.prototype.extractErrorMessage = function (error) {
        var message = error;
        if (error.response) {
            // The client was given an error response (5xx, 4xx)
            //  // console.log("Error", error.response);
            if (error.response.status == 0) {
                message = "Client could not connect to the server";
            }
            else {
                message = "Client was given an error response";
            }
            // message = "Client was given an error response";
        }
        else if (error.request) {
            message = "Client request never left the browser and therefore never received a response from the server ";
        }
        else {
            // Anything else
            //  // console.log("Error", error.message);
            message = error.message;
        }
        //Simulate a normal response so that it wont break the UI.
        return {
            data: {
                success: false,
                message: message,
                content: error,
            },
        };
    };
    return API;
}());
exports.API = API;
